import React, { useEffect, useState } from 'react'
import {connect} from 'react-redux'
import { Layout, Breadcrumb } from 'antd';

import { getSchools } from './actions/school.js'
import { getReports } from './actions/report.js'
import MainFooter from './Home/Footer.js'
import SideBar from './Home/SideBar.js'
import MainHeader from './Home/Header.js';

import Welcome from './views/Welcome'
import School from './views/School'
import Profile from './views/Profile'
import Attendances from './views/AttendanceMenu'
import Attendance from './views/Attendance'
import Fees from './views/FeesMenu';
import Fee from './views/Fee'
import Feedback from './views/Feedback'
import Behavior from './views/Behavior'
import Lessonplan from './views/Lessonplan'
import Lesson from './views/Lesson'
import Note from './views/Note'
import Subject from './views/Subjects'
import { useParams } from 'react-router';
import Reports from './views/ReportsMenu';
import Report from './views/Reports';
import ReportDetails from './views/ReportBreakdown';
import ReportCbt from './views/ReportCbt';

const { Content } = Layout;
function Home(props){
 const [collapsed, setCollapsed] = useState(false)

 const {user, school} = props

 let params = useParams()
 let pathname = params.index
 let pathname1 = params?.index1 || null
 let pathname2 = params?.index2 || null


  useEffect(() => {
    let { schoolId } = user
    let params = {
      data:JSON.stringify(
      {
        'id': schoolId
      }),
      cat:'selected_school',
      table:'schools',
      narration:'get school'
    }
    props.getSchools(params)
  }, [user])

  useEffect(() => {
    let { schoolId, mid } = user
    let params1 = {
      data:JSON.stringify(
      {
        'schoolid': schoolId,
        'studentid': mid
      }),
      cat:'select_result',
      table:'schools',
      narration:'get student records'
    }
    props.getReports(params1)  
  })

  const toggle = () =>{
    setCollapsed(prev=>!prev);
  }
 console.log(pathname1, pathname2)
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <SideBar collapsed={collapsed} setCollapsed={()=>toggle()}/>
        <Layout className="site-layout">
          <MainHeader collapsed={collapsed} toggle={()=>toggle()}  />
          <Content style={{ margin: '0 16px' }}>
             <div className="site-layout-content">
               {pathname === '' || pathname === null || pathname === undefined ? <Welcome />:''}
               {pathname === 'index' ? <School data={school}/>:''}
               {pathname === 'profile' ? <Profile data={props.user.user}/>:''}
               {pathname === 'report'  && pathname1 === null && pathname2 === null ? <Reports data={props.user.user}/>:''}
               {pathname === 'report' && pathname1 > 0 && pathname2 === null ? <Report reportid={pathname1} data={props.user.user}/>:''}
               {pathname === 'report' && pathname1 > 0  && pathname2 > 0 ? <ReportDetails reportid={pathname1} data={props.user.user}/>:''}
               {pathname === 'reportcbt'&& pathname1 === null && pathname2 === null? <ReportCbt reportid={pathname1} data={props.user.user}/>:''}
               {pathname === 'fee' && pathname1 === null ? <Fees data={props.user.user}/>:''}
               {pathname === 'fee' && pathname1 > 0 ? <Fee reportid={pathname1} data={props.user.user}/>:''}
               {pathname === 'attendance' && pathname1 === null ? <Attendances data={props.user.user}/>:''}
               {pathname === 'attendance' && pathname1 > 0 ? <Attendance reportid={pathname1} data={props.user.user}/>:''}
               {pathname === 'subject' && (pathname1 == null || pathname1 == "") && (pathname2 == null || pathname2 == "")   ? <Subject data={props.user.user}/>:''}
               {pathname === 'subject' && pathname1 > 0 && (pathname2 == null || pathname2 == "") ? <Lesson data={props.user.user}/>:''}
               {pathname === 'subject' && pathname1 > 0 && pathname2 > 0 ? <Note data={props.user.user}/>:''}

               {pathname === 'lessonplan' ? <Lessonplan data={props.user.user}/>:''}
               {pathname === 'behavior' ? <Behavior data={props.user.user}/>:''}
               {pathname === 'feedback' ? <Feedback data={props.user.user}/>:''}
             </div>
          </Content>
         <MainFooter />
         </Layout>
      </Layout>
    )

}

const mapStateToProps = (state) => ({
  user:state.userReducer,
  school:state.schoolReducer.school
})

const mapDispatchToProps = {
  getSchools,
  getReports
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)

